import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateEvent from "./CreateEvent";
import { getRoleFromToken } from "../../../auth/adminEmails";

// Admin/Captain-only entry point to the Create Event form. Bounces unauth'd
// users back to /login, then renders CreateEvent in admin mode (no Drew
// password gate, host/submitter fields auto-filled with the admin's email).
const CreateEventAdmin = () => {
  const navigate = useNavigate();
  const [adminEmail, setAdminEmail] = useState("");
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("cognitoIdToken");
    const role = token ? getRoleFromToken(token) : null;
    if (!role) {
      navigate("/login");
      return;
    }
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      setAdminEmail((payload.email || "").toLowerCase());
    } catch {
      setAdminEmail("");
    }
    setAuthReady(true);
  }, [navigate]);

  if (!authReady) return null;

  return <CreateEvent isAdmin adminEmail={adminEmail} />;
};

export default CreateEventAdmin;
